import './AddAppSection.scss';
import classNames from 'classnames';
import React from 'react';
import { SonarText } from '@ui/text';

export interface AddAppSectionProps {
	children: React.ReactNode;
	className?: string;
	headerExtra?: React.ReactNode;
	icon?: React.ReactNode;
	id?: string;
	title: string;
}

export const AddAppSection: React.FC<AddAppSectionProps> = ({
	children,
	className,
	headerExtra,
	icon,
	id,
	title
}) =>
	<div
		className={ classNames('add-app-section', className) }
		id={ id }>
		<SonarText
			className='section-header'
			size={ 20 }
			weight='semibold'>
			{ icon }
			{ title }
			{ headerExtra && <div className='header-extra'>{ headerExtra }</div> }
		</SonarText>
		{ children }
	</div>;
